wbApp.controller('EmployeesCtrl', ['$scope', '$modal', '$translate', '$filter', '$q','employeeSvc', 'securitySvc', 'tenantSettingSvc', 'gridSortSvc', 'groupSvc',
function ($scope, $modal, $translate, $filter, $q, employeeSvc, securitySvc, tenantSettingSvc, gridSortSvc, groupSvc) {

    $scope.groups = groupSvc.getAllAsync(true);
    $scope.customFilter = { selectedGroups: [] };
    $scope.rawEmployees = [];
    $scope.employees = [];

    function preFilter() {
        $q.all([$scope.groups.$promise, $scope.rawEmployees.$promise]).then(function () {
            if (!$scope.customFilter.selectedGroups.length) {
                $scope.employees.length = 0;
                $scope.employees.push.apply($scope.employees, $scope.rawEmployees);
            } else {
                var noGroupSelected = $scope.customFilter.selectedGroups.indexOf(-1) !== -1;

                $scope.employees.length = 0;
                $scope.employees.push.apply($scope.employees,
                    _.filter($scope.rawEmployees, function (o) {
                        if (noGroupSelected) {
                            return !o.groups.length;
                        }

                        return _.intersection(o.groups, $scope.customFilter.selectedGroups).length > 0
                    }));
            }
        });
    }

    $scope.$watch('customFilter.selectedGroups', function (newValue, oldValue) {
        preFilter();
    }, true);

    function onPrintEmployeeTimeSheet(data, isRfidReport, withCarryOver) {
        employeeTimeSheetParamsDialog.$promise.then(function () {
            employeeTimeSheetParamsDialog.$scope.employeeID = data.employeeID;
            employeeTimeSheetParamsDialog.$scope.withCarryOver = withCarryOver;
            employeeTimeSheetParamsDialog.$scope.isRfidReport = isRfidReport;
            employeeTimeSheetParamsDialog.show();
        });
    }

    function setSelectedEmployee(data) {
        $scope.selectedEmployee = data;
        $scope.$broadcast('employeeSelectionChanged', $scope.selectedEmployee);
    }

    $scope.enableZoomIntegration = tenantSettingSvc.settings.enableZoomIntegration;
    $scope.enableNewClientDesign = tenantSettingSvc.settings.enableNewClientDesign;

    $scope.gridSettings = {
        name: 'employees',
        keyExpr: 'employeeID',
        columns: [
            { dataField: 'active', caption: $translate.instant('TXT_LBL_ACTIVE'), dataType: 'boolean', width: '60px' },
            {
                dataField: 'fullName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string', width: '190px', sortOrder: 'asc',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName(data, 'name', 'surname', 'middleName') }
            },
            { dataField: 'jobDescription', caption: $translate.instant('TXT_LBL_JOB_DESCRIPTION'), dataType: 'string' },
            { dataField: 'email', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '180px' },
            {
                dataField: 'phone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.phone);
                },
                width: '140px'
            },
            { dataField: 'isPublicProfile', caption: $translate.instant('TXT_LBL_PUBLIC_PROFILE'), dataType: 'boolean', width: '60px', visible: $scope.enableNewClientDesign },
            { dataField: 'teachingOnlineCourses', caption: $translate.instant('TXT_LBL_TEACHING_ONLINE_COURSES'), dataType: 'boolean', width: '60px', visible: $scope.enableZoomIntegration },
            { dataField: 'smallImage', caption: $translate.instant('TXT_LBL_PICTURE'), dataType: 'boolean', width: '60px' },
        ],
        customCommands: [{
            text: $translate.instant('TXT_MENU_PRINT_EMPLOYEE_TIME_SHEET'),
            isVisible: function () { return securitySvc.isInRole('Employee.TimeSheet') && securitySvc.isInRole('Reports'); },
            callback: function (data) { onPrintEmployeeTimeSheet(data, false, false); }
        }, {
            text: $translate.instant('TXT_MENU_PRINT_EMPLOYEE_TIME_SHEET_WITH_CARRY_OVER'),
            isVisible: function () { return securitySvc.isInRole('Employee.TimeSheet') && securitySvc.isInRole('Reports'); },
            callback: function (data) { onPrintEmployeeTimeSheet(data, false, true); }
        }, {
            text: $translate.instant('TXT_MENU_PRINT_EMPLOYEE_TIME_SHEET_RFID'),
            isVisible: function () { return securitySvc.isInRole('Employee.TimeSheet') && securitySvc.isInRole('Reports') && tenantSettingSvc.settings.enableRfidCardSupport; },
            callback: function (data) { onPrintEmployeeTimeSheet(data, true, false); }
        }]
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.rawEmployees = employeeSvc.getAllNonDeleted(true);
        setSelectedEmployee(null);
    });

    $scope.rawEmployees = employeeSvc.getAllNonDeleted(true);

    preFilter();

    $scope.tabs = [
        {
            title: 'TXT_DETAIL',
            template: "users/employees/detail-tabs/detail.html"
        }
    ];

    if (tenantSettingSvc.settings.enableReservationSupport)
    {
        $scope.tabs.push({
            title: 'TXT_AVAILABILITY_SCHEDULE',
            template: 'users/employees/detail-tabs/availability-schedule.html'
        })
    }

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.rawEmployees;
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onSave = function () {
                preFilter();
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.rawEmployees;
            detailDialogPromise.$scope.model = employeeSvc.createNew();
            detailDialogPromise.$scope.onSave = function () {
                preFilter();
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        employeeSvc.remove(data, function () {
            preFilter();
        }, null, $scope.rawEmployees);
    }

    $scope.onRowSelected = function (data) {
        setSelectedEmployee(data);
    }

    var detailDialogPromise = $modal({
        templateUrl: 'users/employees/employees-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var employeeTimeSheetParamsDialog = $modal({
        templateUrl: 'users/employees/employees-time-sheet-report-params.html',
        show: false,
        scope: $scope.$new()
    });

}]);
